<app-dialog-header [title]="title" [additionalText]="totalCount" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <div class="content white w-100-p" *ngIf="!isPageLoading; else shimmer">
        <mat-tab-group class="border border-gray-200" (selectedTabChange)="onTabChanged($event)">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.label | translate">
                <div *ngIf="!isTabLoading; else shimmer">
                    <div *ngIf="tab.dataSource.data.length; else noMessages">
                        <mat-table [dataSource]="tab.dataSource.data">
                            <ng-container *ngFor="let column of tab.columns" [matColumnDef]="column.name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header="{{ column.sortable ? '' : null }}">
                                    {{ column.header ? (column.header | translate) : '' }}
                                </mat-header-cell>

                                <mat-cell *matCellDef="let message">
                                    <ng-container *ngIf="column.cellTemplate === 'avatarCell'">
                                        <div *ngIf="job.type === 'user_import'; else avatar">
                                            <mat-icon class="text-gray-400">cloud_upload</mat-icon>
                                        </div>

                                        <div class="relative">
                                            <ng-template #avatar>
                                                <img class="avatar pointer" *ngIf="message.imageUrl; else initials" [alt]="message.title" [src]="message.imageUrl" />
                                                <ng-template #initials>
                                                    <ng-container *ngIf="message.module; else userInitials">
                                                        <div class="avatar" fxLayoutAlign="center center">
                                                            <mat-icon [svgIcon]="message.module | getModuleIcon"></mat-icon>
                                                        </div>
                                                    </ng-container>
                                                    <ng-template #userInitials>
                                                        <div fxLayoutAlign="center center" class="avatar-initials avatar">
                                                            {{ message.title | initials }}
                                                        </div>
                                                    </ng-template>
                                                </ng-template>
                                            </ng-template>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngIf="column.cellTemplate === 'nameCell'">
                                        <span class="text-truncate font-semibold w-100-p">{{ message.title | translate }}</span>
                                    </ng-container>

                                    <ng-container *ngIf="column.cellTemplate === 'defaultCell'">
                                        {{ message[column.name] }}
                                    </ng-container>

                                    <ng-container *ngIf="column.cellTemplate === 'errorCell'">
                                        {{ 'ERROR.RESPONSE.' + message.errorInfo.message | translate }}
                                    </ng-container>

                                    <ng-container *ngIf="column.cellTemplate === 'resultCell'">
                                        <ng-container *ngIf="message.resultInfo?.message">
                                            {{ 'ERROR.RESPONSE.' + message.resultInfo.message | translate }}
                                        </ng-container>
                                    </ng-container>
                                </mat-cell>
                            </ng-container>
                            <mat-row *matRowDef="let row; columns: tab.columnNames" class="py-8"></mat-row>
                        </mat-table>

                        <mat-paginator persistPageSize="shared.job-details-dialog"
                            [length]="asyncJobService.messagesPagination.numberOfResults"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="[5, 10, 25, 50]"
                            (page)="onPageChange($event, tab.key)"
                        ></mat-paginator>
                    </div>

                    <ng-template #noMessages>
                        <div class="no-results-container my-48" fxLayout="column" fxLayoutAlign="center center">
                            <mat-icon class="participant-view-illustration" svgIcon="opened_folder"></mat-icon>
                            <h2 class="mt-8">{{ 'GENERAL.LABEL.NO_RESULTS_FOUND' | translate }}</h2>
                        </div>
                    </ng-template>
                </div>

                <ng-template #shimmer>
                    <div class="shimmer-container min-w-full p-24">
                        <div class="shimmer">
                            <div class="shimmer-card table animate"></div>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>

    <ng-template #shimmer>
        <div class="shimmer-container min-w-full">
            <div class="shimmer">
                <div class="shimmer-card table animate"></div>
            </div>
        </div>
    </ng-template>
</div>
